import { Record } from "immutable";
import { EventType } from "models/enumerations/events/event-type";
import { ResultClickedEvent } from "models/interfaces/events/result-clicked-event";

const defaultValues: ResultClickedEvent = {
    type: EventType.ResultClicked,
    resultClickedEvent: {
        path: "",
        chunkId: "",
        rank: 0,
    },
    sessionId: "",
};

export default class ResultClickedEventRecord
    extends Record(defaultValues)
    implements ResultClickedEvent
{
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params: Partial<ResultClickedEvent> = {}) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    public with(values: Partial<ResultClickedEvent>): ResultClickedEventRecord {
        return new ResultClickedEventRecord(
            Object.assign(this.toJS(), values) as ResultClickedEvent
        );
    }

    // #endregion Public Methods
}
